import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setCredentials, logOut } from "../../features/auth/authSlice";
import { SKORBOARD_URL } from "../../constants/endpoints";
import { pushFaroEvent } from "../../services/faro";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BACKEND_URL,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      headers.set(
        "Access-Control-Allow-Origin",
        process.env.REACT_APP_SERVER_URL
      );
    }
    return headers;
  },
});

export const baseQueryWithReAuth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  const endpoint = typeof args === "string" ? args : args?.url || "unknown";
  const method = typeof args === "string" ? "GET" : args?.method || "GET";

  if (result?.error) {
    const status = result.error.status;

    if (status === "FETCH_ERROR") {
      pushFaroEvent(
        "network_failure",
        { endpoint, method, error: result.error.error || "fetch failed" },
        "api"
      );
    } else {
      pushFaroEvent(
        "api_error",
        { status: String(status), endpoint, method },
        "api"
      );
    }
  }

   // ✅ If 404 and user not found, log out
   if (
    result?.error?.status === 404 &&
    result?.error?.data?.message === "User not found"
  ) {
    api.dispatch(logOut());
    window.location.reload();
  }

  // ✅ handle 401 (unauthorized) or token expiry
  if (result?.error?.status === 401 && !endpoint.startsWith(SKORBOARD_URL)) {
    pushFaroEvent("session_expired", { endpoint, method }, "auth");
    api.dispatch(logOut());
    window.location.reload();
    // console.log("Sending refresh token request");

    // const refreshResult = await baseQuery(
    //   "/auth/refresh-token",
    //   api,
    //   extraOptions
    // );

    // console.log(refreshResult);

    // if (refreshResult.data != null) {
    //   const user = api.getState().auth.user;

    //   const { accessToken } = refreshResult.data.data;

    //   api.dispatch(setCredentials({ token: accessToken, user }));

    //   result = await baseQuery(args, api, extraOptions);
    // } else {
    //   api.dispatch(logOut());
    // }
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReAuth,
  endpoints: (builder) => ({}),
});
